const TrendUpThin = (): JSX.Element => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 11.3327L6 7.33268L8.66667 9.99935L14 4.66602" stroke="#EF4444" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.3333 4.66602H14V7.33268" stroke="#EF4444" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default TrendUpThin